import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: number): string {
    if (value >= 1000000000) {
        return (value / 1000000000).toFixed(0) + 'B';
      } else if (value >= 1000000) {
        return (value / 1000000).toFixed(0) + 'M';
      } else if (value >= 1000) {
        return (value / 1000).toFixed(1) + 'k';
      }
      return value.toString();
    }
}



@Pipe({
  name: 'messageTimePipe'
})
export class MessageTimePipe implements PipeTransform {

  transform(value: string | number): string {
    // Convert string to number if necessary
    const timestamp = typeof value === 'string' ? Number(value) : value;

    if (isNaN(timestamp) || timestamp <= 0) return 'Invalid Date';

    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return 'Invalid Date';

    const now = new Date();
    const diffInMs = now.getTime() - date.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit'
    };
    const timeString = date.toLocaleTimeString([], timeOptions);

    if (diffInDays === 0) {
      return `Today, ${timeString}`;
    } else if (diffInDays === 1) {
      return `Yesterday, ${timeString}`;
    } else {
      const dateOptions: Intl.DateTimeFormatOptions = {
        month: 'long',
        day: 'numeric'
      };
      const dateString = date.toLocaleDateString([], dateOptions);
      return `${dateString}, ${timeString}`;
    }
  }
}
